import React from 'react';

import { Box } from '@chakra-ui/react';

import { useContainer } from '../../hooks/use-container';
import { repeatFirstTimesN } from '../../misc/utilities';

export const Container = ({ children, ...rest }) => {
	const { MAX_W, DESIRED_P_VW, MIN_P_PX, MAX_P_PX, NUM_FULL_W_BREAKPOINTS } = useContainer();

	return (
		<Box
			w={repeatFirstTimesN(NUM_FULL_W_BREAKPOINTS)(['100%', '90vw'])}
			maxW={`${MAX_W}px`}
			mx="auto"
			px={`clamp(${MIN_P_PX}px, ${DESIRED_P_VW}vw, ${MAX_P_PX}px)`}
			{...rest}
		>
			{children}
		</Box>
	);
};
